import { Tag } from 'antd'

// Components Library
import GeoLocation from '../../../components/GeoLocation'
import IOTag from '../../../components/Decoration/IOTag'
import CellSignalIcon from '../../../components/EventStatusIcon/components/CellSignalIcon'
import GNSSSignalIcon from '../../../components/EventStatusIcon/components/GNSSSignalIcon'
import { ButtonLink } from '../../../components'

// Redux Actions
import { RoundUp, TIME } from "../../../services/util";

import { table_handler, report_handler } from '../../../handlers'
// import { VideoCameraFilled } from '@ant-design/icons'

import { TEMPLATE } from '../../../constants'

const {
    PRETRIP_HISTORY_STATUS_LABEL,
    PRETRIP_HISTORY_STATUS
} = TEMPLATE.PRETRIP

const { getColumnSearchProps } = table_handler
const {
    DERIVATIVE_DATA_TYPE,
    speedSelector
} = report_handler
const { parseDate, parseTime, parseDuration } = TIME

// const {
//   DRIVER_PRETRIP_RISK_COLOR
// } = TEMPLATE.DRIVER


export const COL_ATTENDENCE_LOG = (searchTextState, searchedColumnState) => [
  {
    title: "Driver",
    dataIndex: "name",
    ...getColumnSearchProps("Driver", 'name', searchTextState, searchedColumnState),
  },
  {
    title: "Driver IC",
    dataIndex: "ic",
    ...getColumnSearchProps("Driver IC", 'ic', searchTextState, searchedColumnState),
  },
    {
    title: "Vehicle Plate",
    dataIndex: "plate",
    fixed: 'left',
    ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
  },
  {
    title: "IC Serial Number",
    dataIndex: "serial_number",
    ...getColumnSearchProps("IC Serial Number", "serial_number", searchTextState, searchedColumnState),
  },
  {
      title: "Tag Time",
      dataIndex: "registeredAt",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.registeredAt - b.registeredAt,
      render: registeredAt => parseDate(Number(registeredAt)),
  },
  {
    title: "Location",
    dataIndex: "location",
    render: registeredAt => parseDate(Number(registeredAt)),
  },
];

export const COL_DAILY_PERFORMANCE = (searchTextState, searchedColumnState) => [
   {
      title: "Date",
      dataIndex: "reportTime",
      sorter: (a, b) => a.reportTime - b.reportTime,
      render: reportTime => parseDate(Number(reportTime)),
  },
  {
    title: "Driver",
    dataIndex: "name",
    ...getColumnSearchProps("Driver", 'name', searchTextState, searchedColumnState),
    render: data => data
  },
  {
    title: "Driver IC",
    dataIndex: "icNumber",
    ...getColumnSearchProps("Driver IC", 'icNumber', searchTextState, searchedColumnState),
    render: data => data
  },
    {
    title: "Vehicle Plate",
    dataIndex: "plate",
    ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
    render: data => data || "-"
  },
//   {
//     title: "Assigned Route",
//     dataIndex: "assigned_route",
//     ...getColumnSearchProps("Assigned Route", 'assigned_route', searchTextState, searchedColumnState),
//     render: (data) => data || '-'
//   },
//   {
//     title: "Delayed Orders",
//     dataIndex: "delayedTime",
//     sorter: (a, b) => a.delayedTime - b.delayedTime,
//     render: (data) => data || '-'
//   },
  {
    title: "Average Speed",
    dataIndex: "averageSpeed",
    sorter: (a, b) => a.averageSpeed - b.averageSpeed,
    render: (data = 0) => `${Number(data).toFixed(2)}km/h`,
  },
  {
    title: "Distance Travelled",
    dataIndex: "plat_daily_mileage",
    sorter: (a, b) => a.plat_daily_mileage - b.plat_daily_mileage,
    render: (data = 0) => `${Number(data).toFixed(2)}km`,
  },
  {
    title: "Average Trip Duration",
    dataIndex: "trip_duration",
    sorter: (a, b) => a.trip_duration - b.trip_duration,
    render: (data) => Number.isFinite(data) ? parseDuration(data || 0) : '-'
  },
  {
    title: "Idling Time",
    dataIndex: "totalIdlingDuration",
    sorter: (a, b) => a.totalIdlingDuration - b.totalIdlingDuration,
    render: (data) => parseDuration(data)
  },
  {
    title: "Harsh Events",
    dataIndex: "harshEvent",
    sorter: (a, b) => a.harshEvent - b.harshEvent,
  },
  {
    title: "Speeding",
    dataIndex: "speeding",
    sorter: (a, b) => a.speeding - b.speeding,
  },
  {
    title: "Video Alarms",
    render: (data) =>  data.total_mdvr_alarm || data.attachments_alarm || 0,
    sorter: (a, b) => a.total_mdvr_alarm - b.total_mdvr_alarm,
  },
  {
    title: "Total Incidents",
    dataIndex: "total_incidents",
    render: (data) => data || 0,
    sorter: (a, b) => a.total_incidents - b.total_incidents,
  },
  {
    title: "Overall Score",
    dataIndex: "overallScore",
    render: (data = 0) => Number(data).toFixed(2),
    sorter: (a, b) => a.overallScore - b.overallScore,
  },
];

export const COL_INCIDENT_LOG = (searchTextState, searchedColumnState, setHDLR) => [
   {
      title: "Datetime",
      dataIndex: "incidentTime",
      sorter: (a, b) => a.incidentTime - b.incidentTime,
      render: incidentTime => TIME.parseTime(Number(incidentTime)),
  },
  {
    title: "Driver",
    dataIndex: "name",
    ...getColumnSearchProps("Driver", 'name', searchTextState, searchedColumnState),
    render: data => data
  },
  {
    title: "Driver IC",
    dataIndex: "icNumber",
    ...getColumnSearchProps("Driver IC", 'icNumber', searchTextState, searchedColumnState),
    render: data => data
  },
    {
    title: "Vehicle Plate",
    dataIndex: "plate",
    ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState),
    render: data => data
  },
  {
    title: "Contact Number",
    dataIndex: "contact",
    ...getColumnSearchProps("Contact Number", 'contact', searchTextState, searchedColumnState),
    render: data => data
  },
  {
    title: "Location",
    dataIndex: "location",
    ...getColumnSearchProps("Location", 'location', searchTextState, searchedColumnState),
    render: data => data
  },
  {
    title: "Description",
    dataIndex: "description",
    ...getColumnSearchProps("Description", 'description', searchTextState, searchedColumnState),
    render: description => {

        return description ? 
            (
                <>
                    <ButtonLink onClick={() => setHDLR(true, description)}>View</ButtonLink>
                </>
            ) : (
                <span style={{ color: 'gray' }}>View</span>
            );
        },
  },
{
    title: "Attachment",
    render: (record) => {
    const { attachments } = record;

    return attachments?.length > 0 ? 
        (
            <>
                <ButtonLink onClick={() => setHDLR(true, attachments)}>View</ButtonLink>
            </>
        ) : (
            <span style={{ color: 'gray' }}>View</span>
        );
    },
},
  {
    title: "Performance Deduction",
    dataIndex: "deduction",
    ...getColumnSearchProps("Performance Deduction", 'deduction', searchTextState, searchedColumnState),
    render: data => data || 0
  },
];

export const COL_HISTORY_PRETRIP = (searchTextState, searchedColumnState, setHDLR) => [
   {
      title: "Date",
      dataIndex: "createdAt",
      sorter: (a, b) => a.createdAt - b.createdAt,
      render: createdAt => TIME.parseTime(Number(createdAt)),
  },
   {
      title: "Day",
      dataIndex: "createdAt",
      sorter: (a, b) => a.createdAt - b.createdAt,
      render: createdAt => TIME.getDayFullFormat(Number(createdAt)),
  },
   {
      title: "Status",
      dataIndex: 'status',
        filters: Object.values(PRETRIP_HISTORY_STATUS).map(hs => {
            return {
                text: PRETRIP_HISTORY_STATUS_LABEL[hs]?.label,
                value: hs
            }
        }),
        onFilter: (value, record) => record.status === value,
        render: data => {
            return <Tag color={PRETRIP_HISTORY_STATUS_LABEL[data]?.tagColor}>{PRETRIP_HISTORY_STATUS_LABEL[data]?.label}</Tag>
        }
  },
      {
    title: "Vehicle Plate",
    dataIndex: "plate",
    ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState),
    render: data => data
  },
     {
      title: "Submitted At",
      dataIndex: "createdAt",
      sorter: (a, b) => a.createdAt - b.createdAt,
      render: createdAt => TIME.parseTime(Number(createdAt)),
  },
    {
    title: "Action",
    render: data => {
      return data.pretripDetails && <ButtonLink onClick={() => setHDLR(true, data)}>View Report</ButtonLink>
    }
  },

];

export const COL_DEVICE_LOG = ({exportState, geofences, searchTextState, searchedColumnState}) => [
    {
        title: 'Vehicle',
        key: 'vehicle',
        dataIndex: 'plate',
        // dataIndex: 'vid',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: data => data,
    },
    {
        title: "Vehicle Time",
        key: 'deviceTime',
        dataIndex: "deviceTime",
        render: (time) => parseTime(time),
         sorter: (a, b) => a.deviceTime - b.deviceTime,
    },
    {
        title: 'Server Time',
        key: 'createdAt',
        dataIndex: 'createdAt',
        render: (time) => parseTime(time),
    },
    {
        title: 'Device IMEI',
        key: 'deviceIMEI',
        dataIndex: 'dvid',
        ...getColumnSearchProps("Device IMEI", 'dvid', searchTextState, searchedColumnState),
        render: (data) => data?.split('#')[1],
    },
    {
        title: 'Data Package',
        key: 'devicePackage',
        dataIndex: 'devicePackage',
        render: (data) => data,
        ...getColumnSearchProps("Device Package", 'devicePackage', searchTextState, searchedColumnState)
    },
    {   title: 'Connectivity',
        key: 'connectivity',
        dataIndex: 'connectivity',
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> :  (data ? 'ON' : 'OFF')
    },
    {   title: 'Cell Signal',
        key: 'cell_signal',
        render: (rowData) => !exportState ? <CellSignalIcon vehicle={rowData}/> : `${rowData.cell_signal || rowData.connectivity }` 
    },
    {
        title: "GPS Status",
        key: "gnss_status",
        render: (rowData) => !exportState ?  <GNSSSignalIcon vehicle={rowData}/> : rowData.gnss_status
    },
    {
        title: "Engine Ignition",
        key: "ignition",
        dataIndex: "ignition",
        render: (data) => !exportState ?  <IOTag io={data} /> :  (data ? 'ON' : 'OFF')
    },
    {
        title: "Location",
        key: "location",
        dataIndex: "location",
        render: (data = {}) => !exportState ? <GeoLocation location={data}/> :`${data.lat}, ${data.lon}`
    },
    {
        title: "Geofence In",
        key: "geoIN",
        dataIndex: "geoIN",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                !exportState ? 
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
                :
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
            )
            ||
            '-'
    },
    {
        title: "Geofence Out",
        key: "geoOUT",
        dataIndex: "geoOUT",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                !exportState ? 
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
                :
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
            )
            ||
            '-'
    },
    {
        title: "Speed (km/h)",
        key: "speed",
        render: (rowData) => speedSelector(rowData, DERIVATIVE_DATA_TYPE.STATE),
        sorter: (a, b) => a.speed - b.speed,
    },
    {
        title: "Altitude",
        key: "altitude",
        dataIndex: "altitude",
        render: (data) => data
    },
    {
        title: "Direction (Degree)",
        key: "heading",
        dataIndex: "heading",
        render: (data) => data
    },
    {
        title: "External Voltage (V)",
        key: "externalVoltage",
        dataIndex: "pwr_ext_v",
        render: (data) => RoundUp(Number(data), 3),
        sorter: (a, b) => a.pwr_ext_v - b.pwr_ext_v
    },
    {
        title: "Battery Voltage (V)",
        key: "batteryVoltage",
        dataIndex: "pwr_int_v",
        render: (data) => RoundUp(Number(data), 3),
        sorter: (a, b) => a.pwr_int_v - b.pwr_int_v

    },
    {
        title: "Battery Current (A)",
        key: "batteryCurrent",
        dataIndex: "pwr_int_i",
        render: (data) => RoundUp(Number(data), 3),
        sorter: (a, b) => a.pwr_int_i - b.pwr_int_i

    },
    {
        title: 'Digital Output 1',
        key: "do_1",
        dataIndex: "do_1",
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> : data
    },
    {
        title: 'Digital Input 1',
        key: "di_1",
        dataIndex: "di_1",
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> :  data
    },
    {
        title: 'Analog Input 1',
        key: "ai_1",
        dataIndex: "ai_1",
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> :  data  
    }
]